module.exports = __webpack_public_path__ + "img/lens-guide-cover.3a007b0.jpg";